/**
 * @generated SignedSource<<06f047bff0c55ec912cfc474df83c0f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanyDashboard_company$data = {
  readonly reportMetrics: ReadonlyArray<{
    readonly name: string;
    readonly value: number | null;
  } | null>;
  readonly latestReport: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly periodStart: any | null;
        readonly periodEnd: any | null;
      };
    }>;
  };
  readonly " $fragmentType": "CompanyDashboard_company";
};
export type CompanyDashboard_company$key = {
  readonly " $data"?: CompanyDashboard_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyDashboard_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanyDashboard_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReportMetricResult",
      "kind": "LinkedField",
      "name": "reportMetrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "latestReport",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "PERIOD_END_DESC",
            "CREATED_AT_DESC"
          ]
        }
      ],
      "concreteType": "ReportsConnection",
      "kind": "LinkedField",
      "name": "reports",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReportsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Report",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "periodStart",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "periodEnd",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "reports(first:1,orderBy:[\"PERIOD_END_DESC\",\"CREATED_AT_DESC\"])"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "5bc6f135c3256f5eddcdea38dec25c57";

export default node;
